import { ChangeDetectorRef, Renderer2, TemplateRef } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { CommonService } from 'src/app/_services/common.service';
import { DashboardService } from './services/dashboard.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { formatMarkdown } from 'src/app/_services/markdown.util';
import { AiService, CommentSummaryModel, InteractionSummaryModel } from './services/ai.service';

declare let $: any;
@Component({
  selector: 'tangram-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @ViewChild('UnlockPremiumModalContent', { static: true }) unlockPremiumModalContent!: TemplateRef<any>;
  @ViewChild('AlertContent', { static: true }) alertContent!: TemplateRef<any>;
  @ViewChild('PasswordPromptModalContent', { static: true }) passwordPromptModalContent!: TemplateRef<any>;
  @ViewChild('DeleteConfirmContent', { static: true }) deleteConfirmContent!: TemplateRef<any>;
  isDashboard: boolean = true;
  isMobile: boolean = false;
  iconPath = appConfig.iconPath;
  videoData: null;
  /** pathway detail */
  public pathwayDetail: any = {
    title: '',
    description: ''
  }
  public isPrivate: boolean = false; // To store if pathway is private
  public isInviteOnly: boolean = false; // To store if pathway is invite-only
  public canManage: boolean = false; // To store if current user can manage (creator or editor)
  public ratingCounts = {};
  userRatings = {}; // To store user video ratings
  public videosDuration = { totalVideo: '', totalVideoMinutes: '' }; // To store videos duration details
  /** pass curated info to the component */
  public curatorInfo: any = {
    _id: null,
    firstName: '',
    lastName: ''
  };
  /** pass content processed data to the component */
  public contentProcessed: any = {
    data: 0
  };
  public currentVideoDetail: any = { _id: '' }; // To store current video detail
  public trackVideoDetail = {}; // To store track video detail
  upskills: any[]; // To store upskills

  playlists: any[]; // To store playlist
  thumbnailsList: any[];
  spotlights: any[]; // To store spotlights
  videoId: string = ""; // To store video id
  // upskill scroll event for mobile
  @ViewChild('upskillWeb', { static: false }) upskillWeb: ElementRef;
  showDashboardSubScription: Subscription;
  scrollToUpSkillSubScription: Subscription;
  openSpotLightModalSubScription: Subscription;
  changeViewSubscription: Subscription;
  refreshEngagementQuestionsSubscription: Subscription;
  showDashboardOverviewView: boolean = true; // To show hide dashboard overview view
  showForumView: boolean = false; // To show hide forum view
  showForumQuestionView: boolean = false; //To show hide forum question view
  tag: any;
  pathwayId: string = ""; // To store pathway id
  createdBy: string = ""; // To store createdBy id
  overviewImageUrl: string = ""; // To store image url
  videoURL: any = "";
  showFeedbackModal: boolean;
  aiChatIsOpen: boolean = false;
  aiChatVisible: boolean = false;
  private aiChatDelayTimer: any = null;
  learningRoadmapVisible: boolean = false;
  private learningRoadmapDelayTimer: any = null;

  visibility: string = ""; // To check id public page or not
  publicVisibility: boolean = false;
  currentUser: any;
  isPathwayListRoute: boolean = false;
  currentPathwayId: any = '';
  isCurrentScreenVideo: boolean = false;
  isvideoAvailable: boolean = false;
  platForm: string = '';
  isCommentDisable: boolean = false;
  followedUsers: any[] = [];
  followedThisUser: boolean = false;
  numberOfCurators: number = 0;
  alterMessage: string = ''
  createPage: boolean = false; // To store create page or not

  // Password Protection Properties
  pathwayPassword: string = '';
  passwordPromptError: string = '';
  showPassword: boolean = false; // To toggle password visibility
  pendingVideoAccess: any = null; // Store video that needs password validation
  currentModal: any = null; // Store current modal reference
  showPasswordAlert: boolean = true
  showSuccessButton: boolean = true;
  haveInviteOnlyAccess: boolean = false;


  // Zoom functionality properties
  iframeScale: number = 1;
  currentIframeElement: HTMLIFrameElement | null = null;
  // Removed zoom limits to allow infinite zoom

  // Image zoom properties
  imageScale: number = 1;
  // Removed image zoom limits to allow infinite zoom

  // Expanded modal zoom properties
  expandedIframeScale: number = 1;
  expandedImageScale: number = 1;

  // Completion properties
  isCompleted: boolean = false;
  completionPercentage: number = 0;
  completedVideoIds: string[] = [];

  // Personal Notes properties
  isNotesExpanded: boolean = false;
  newNoteText: string = '';
  isNotePrivate: boolean = false;
  personalNotes: any[] = [];

  // Engagement properties
  showQuestionModal: boolean = false;
  showPollModal: boolean = false;
  showAiSuggestions: boolean = false;

  // Questions properties
  isQuestionsExpanded: boolean = true;
  expandedQuestionId: string = '';
  newQuestionText: string = '';
  newQuestionType: string = 'Open-Ended';
  newQuestionOptions: string[] = ['', ''];
  editingQuestionId: string = '';
  questions: any[] = [];

  // Delete confirmation
  pendingDeleteItem: any = null;
  pendingDeleteType: string = '';

  // Polls properties
  isPollsExpanded: boolean = true;
  expandedPollId: string = '';
  newPollQuestion: string = '';
  pollOptions: string[] = ['', ''];
  allowMultipleSelections: boolean = false;
  editingPollId: string = '';
  polls: any[] = [];
  interactionSummary: InteractionSummaryModel | null = null;
  interactionSummaryLoading: boolean = false;
  interactionSummaryError: string = '';
  commentSummary: CommentSummaryModel | null = null;
  commentSummaryLoading: boolean = false;
  commentSummaryError: string = '';
  publicCommentCount: number = 0;


  constructor(
    private cd: ChangeDetectorRef,
    private dashboardService: DashboardService,
    private renderer: Renderer2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private toasterService: ToastrService,
    private aiService: AiService
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param) => {
      if (param.videoId) {
        this.videoId = param.videoId;
        this.isvideoAvailable = true;
        if (!this.currentUser) {
          this.visibility = 'public';
          this.publicVisibility = true;
          if (this.isvideoAvailable) {
            this.isDashboard = false;
            this.getVideoDetail(this.videoId, 'manual', 'public');
          }
        }
      }
    });

    this.activatedRoute.params.subscribe((param) => {
      if (param && param.pathwayId) {
        this.isPathwayListRoute = true;
        this.currentPathwayId = param.pathwayId;
      }
      if (this.activatedRoute.parent.snapshot.routeConfig.path == 'video/:id') {
        this.visibility = 'public';
        this.publicVisibility = true;
      }
      this.getOverviewDetail();
      // Set isFromAM if available
      if (param.id) {
        this.isDashboard = false;
        // this.currentVideoDetail = param.video;
        this.videoId = param.id;
        this.getVideoDetail(param.id, 'manual', 'public');
        // console.log("videoData",this.videoData)
        // this.pathwayDetail = { title: video.title, description: video.description, tagName: video.tag.name };
        // this.isFromAccountManagement = param.isFromAM == "true";
      }
    });

    //call subscription
    this.showDashboardSubScription = this.commonService.showDashboard.subscribe((param: any) => {
      param ? this.onDashboardClick() : '';
    });
    this.scrollToUpSkillSubScription = this.commonService.scrollToUpSkill.subscribe(() => {
      // scroll to particular div-upskill
      this.upskillWeb.nativeElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
    this.openSpotLightModalSubScription = this.commonService.openSpotLightModal.subscribe((param: boolean) => {
      param ? this.openSpotLightModal() : '';
    });
    this.handleChangeViewSubscription();
    this.refreshEngagementQuestionsSubscription = this.commonService.refreshEngagementQuestions.subscribe(() => {
      this.loadEngagementQuestions();
    });
    this.getCuratorsCount();
  }

  /**
  * Called once, before the instance is destroyed.
  */
  ngOnDestroy(): void {
    this.showDashboardSubScription ? this.showDashboardSubScription.unsubscribe() : '';
    this.scrollToUpSkillSubScription ? this.scrollToUpSkillSubScription.unsubscribe() : '';
    this.openSpotLightModalSubScription ? this.openSpotLightModalSubScription.unsubscribe() : '';
    this.refreshEngagementQuestionsSubscription ? this.refreshEngagementQuestionsSubscription.unsubscribe() : '';
    this.renderer.removeClass(document.body, 'video-detail-page');
    if (this.aiChatDelayTimer) {
      clearTimeout(this.aiChatDelayTimer);
    }
    if (this.learningRoadmapDelayTimer) {
      clearTimeout(this.learningRoadmapDelayTimer);
    }
  }

  /**
   * Get overview detail
   */
  getOverviewDetail() {
    this.isCurrentScreenVideo = false;
    this.isPathwayListRoute = true;
    if (this.currentUser || this.visibility !== 'public') {
      if (this.isDashboard) {
        this.renderer.removeClass(document.body, 'video-detail-page');
      }
      this.callFooterCommonEvent();
      const pathwayId = this.currentPathwayId;
      if (this.currentUser) {
        this.dashboardService.getMyFollowingUsers().subscribe((users) => {
          this.followedUsers = users.data
        })
      }

      this.dashboardService.getPathwayDetail(pathwayId).subscribe((data: any) => {
        // Bind curator information
        const { _id, title, description, imageURL, tempImageURL, ratingCounts, totalVideos, totalDurationMIN, videos, upskills, totalVideoWatchPercentage, createdBy } = data.data;

        this.curatorInfo = data.data.admin;
        this.followedThisUser = this.followedUsers.some((user) => user._id === this.curatorInfo._id)
        // console.log('this.followedThisUser: ', this.followedThisUser);
        // Extract privacy information
        this.isPrivate = data.data.isPrivate || false;
        this.isInviteOnly = data.data.isInviteOnly || false;

        // Extract necessary details from response
        if (this.isInviteOnly && this.currentUser && this.currentUser._id !== this.createdBy) {
          this.checkInviteOnlyAccess(pathwayId)
        }

        this.pathwayId = _id;
        this.createdBy = createdBy;

        // Set initial access control
        this.canManage = this.currentUser && this.currentUser._id === this.createdBy;
        // Check if user has access to private tangram
        if (this.isPrivate && this.currentUser && this.currentUser._id !== this.createdBy) {
          this.showPrivateAccessAlert();
          return;
        }
        // Bind pathway id in localstorage
        localStorage.setItem("pathwayId", this.pathwayId);
        if (imageURL) {
          this.overviewImageUrl = `${environment.backendUrl}${imageURL}`;
        } else if (tempImageURL) {
          this.overviewImageUrl = tempImageURL;
        }
        else {
          this.overviewImageUrl = "assets/img/videos/img6.png";
        }

        this.commonService.raiseEventToGetPathwayInHeaderAndFooter(this.pathwayId);
        // Bind total video watch percentage for overview
        this.contentProcessed.data = totalVideoWatchPercentage;
        // Bind detail like title and description
        this.pathwayDetail = { title, description };
        // Bind different counts like users, likes, comments, questions
        this.ratingCounts = ratingCounts;
        this.videosDuration = { totalVideo: totalVideos, totalVideoMinutes: totalDurationMIN };
        // if (this.playlists == undefined) {
        // Bind videos
        this.playlists = videos;
        this.thumbnailsList = [...this.playlists]
        // }
        // Bind upskills
        this.upskills = upskills;

        // Load Phase 1 data
        this.loadCompletionData();
        this.loadPersonalNotes();
        this.loadEngagementQuestions();
        this.loadPolls();
        this.loadInteractionSummary();
        this.scheduleAiChatRender();
        this.scheduleLearningRoadmapRender();

        if (this.isvideoAvailable) {
          this.isDashboard = false;
          this.getVideoDetail(this.videoId, 'manual');
        }
      }, error => {
        if (error.status == 400 && error.error.message == "Please select topic") {
          this.router.navigate(['/configuration/preferences/5']);
        }

      });
    }
  }

  /**
   * Get video detail
   */
  getVideoDetail(videoId, from = '', visibility = '') {
    this.isCurrentScreenVideo = true;
    this.isPathwayListRoute = false;
    if (!this.isDashboard) {
      this.renderer.addClass(document.body, 'video-detail-page');
    }

    this.callFooterCommonEvent();
    if (visibility == 'public') {
      this.dashboardService.getVideoDetailPublic(videoId).subscribe((data: any) => {
        const { spotlights, ratingCounts, isLiked, tag, isDisliked, isFavourite, pathwayId, platForm, videoURL } = data.data;
        this.currentPathwayId = pathwayId;
        if (from == 'manual') {
          this.currentVideoDetail = data.data;
          this.pathwayDetail = { title: data.data.title, description: data.data.description, tagName: data.data.tag.name };
        }
        this.pathwayId = data.data.pathwayId;
        this.commonService.raiseEventToGetPathwayInHeaderAndFooter(data.data.pathwayId);
        this.ratingCounts = ratingCounts;
        this.userRatings = { isLiked, isDisliked, isFavourite };
        this.spotlights = spotlights;
        // video dashboard
        this.tag = tag;
        this.loadCommentSummary();
        this.videoURL = this.getSafeUrl(videoURL)
        if (platForm == 'Other') {
          if (videoURL.includes('spreadsheets') || videoURL.includes('document') || videoURL.includes('drive')) {
            const urlParts = videoURL.split('/');
            urlParts[urlParts.length - 1] = 'preview';
            const iframeURL = urlParts.join('/');
            console.log('iframeURL: ', iframeURL);
            this.videoURL = this.getSafeUrl(iframeURL)
          } else {
            const notAddProxy = ['wikipedia', 'axios', 'cbsnews', 'instructure.com', 'canvas-user-content.com', 'inst-fs-iad-prod.inscloudgate.net'];
            const enCodeURL = encodeURIComponent(videoURL)
            let newProxyURL = environment.proxyWorkerURL + '?id=1&interceptorNotNeeded=true&apiURL=' + enCodeURL;
            if (!environment.production) {
              newProxyURL = environment.proxyWorkerURL + '?id=2&interceptorNotNeeded=true&apiURL=' + enCodeURL;
            }
            const notNeedProxy = notAddProxy.some((value) => videoURL.includes(value))
            if (notNeedProxy) {
              this.videoURL = this.getSafeUrl(videoURL)
            } else {
              this.videoURL = this.getSafeUrl(newProxyURL)
            }
          }
        }
        this.platForm = platForm


        // Make chat stream scrollable
        setTimeout(() => {
          if ($(window).width() >= 992) {
            $('.discussion').css({
              'height': $('.video-section').innerHeight()
            });
          }
        }, 500);
        this.scheduleAiChatRender();
        this.scheduleLearningRoadmapRender();
      });
    } else {
      this.dashboardService.getVideoDetail(videoId).subscribe((data: any) => {
        const { spotlights, ratingCounts, isLiked, tag, isDisliked, isFavourite, platForm, videoURL, disableComment, pathwayId, pathway } = data.data;
        this.isCommentDisable = disableComment
        console.log("pathway", pathway)
        console.log("pathway.isPasswordProtected", pathway.isPasswordProtected)
        console.log("this.currentUser", this.currentUser)
        console.log("this.createdBy", this.createdBy)
        if (pathway && pathway.isPasswordProtected && this.showPasswordAlert && this.currentUser && this.currentUser._id !== this.createdBy) {

          // Check if video is password protected and user is not the creator
          this.pendingVideoAccess = data.data;
          this.openPasswordPrompt();
          return;
        }
        if (from == 'manual') {
          this.currentVideoDetail = data.data;
          this.pathwayDetail = { title: data.data.title, description: data.data.description, tagName: data.data.tag ? data.data.tag.name : '' };
        }

        // Change the platFrom according to the entered link        
        this.videoURL = this.getSafeUrl(videoURL)
        if (platForm == 'Other') {
          if (videoURL.includes('spreadsheets') || videoURL.includes('document') || videoURL.includes('drive')) {
            const urlParts = videoURL.split('/');
            urlParts[urlParts.length - 1] = 'preview';
            const iframeURL = urlParts.join('/');
            console.log('iframeURL: ', iframeURL);
            this.videoURL = this.getSafeUrl(iframeURL)
          } else {
            const notAddProxy = ['wikipedia', 'axios', 'cbsnews', 'instructure.com', 'canvas-user-content.com', 'inst-fs-iad-prod.inscloudgate.net'];
            const enCodeURL = encodeURIComponent(videoURL)
            let newProxyURL = environment.proxyWorkerURL + '?id=1&interceptorNotNeeded=true&apiURL=' + enCodeURL;
            if (!environment.production) {
              newProxyURL = environment.proxyWorkerURL + '?id=2&interceptorNotNeeded=true&apiURL=' + enCodeURL;
            }
            const notNeedProxy = notAddProxy.some((value) => videoURL.includes(value))
            if (notNeedProxy) {
              this.videoURL = this.getSafeUrl(videoURL)
            } else {
              this.videoURL = this.getSafeUrl(newProxyURL)
            }
          }
        }
        // console.log('this.videoURL: ', this.videoURL);

        this.platForm = platForm
        this.ratingCounts = ratingCounts;
        this.userRatings = { isLiked, isDisliked, isFavourite };
        this.spotlights = spotlights;
        // video dashboard
        this.tag = tag;
        this.loadCommentSummary();
        // Make chat stream scrollable
        setTimeout(() => {
          if ($(window).width() >= 992) {
            $('.discussion').css({
              'height': $('.video-section').innerHeight()
            });
          }
        }, 500);
        this.scheduleAiChatRender();
        this.scheduleLearningRoadmapRender();
      });
      this.getTrackedVideoWatchDashboard(videoId);
      this.cd.detectChanges();
      // Update totalViewCount for other platforms
      if (this.platForm !== 'YouTube') {
        const watchDataObject = {
          totalSeconds: 1,
          totalSeenSeconds: 1,
          percentage: 1,
          videoId: videoId
        }
        this.onUpdateConsumedContent(watchDataObject)
      }
    }
    // this.dashboardService.getTrackedVideoWatch(videoId).subscribe((data: any) => {
    //   this.trackVideoDetail = data.data;
    //   this.contentProcessed.data = data.data.percentage;
    // });
  }

  drop(event: CdkDragDrop<string[]>, modalContent: TemplateRef<any>) {
    if (!this.currentUser.subscriptionActive) {
      this.modalService.open(modalContent, { centered: true, windowClass: 'unlock-premium' })
      return;
    }
    if (event.previousIndex == event.currentIndex) return;
    this.thumbnailsList = [];

    const prevItem = this.playlists[event.previousIndex];
    const currItem = this.playlists[event.currentIndex];
    const payload = {
      from: {
        videoId: currItem._id,
        order: event.previousIndex + 1,
      },
      to: {
        videoId: prevItem._id,
        order: event.currentIndex + 1,
      }
    };

    this.dashboardService.updateVideosOrder(payload).subscribe((data) => {
      moveItemInArray(this.playlists, event.previousIndex, event.currentIndex);
      this.thumbnailsList = [...this.playlists]
      // Update thumbnail Image of Tangram
      this.updateOverviewImageUrl(null, this.playlists)
    });
  }

  /**
   * Get video watched status
   * @param videoId videoid watched status
   */
  getTrackedVideoWatchDashboard(videoId) {
    this.dashboardService.getTrackedVideoWatch(videoId).subscribe((data: any) => {
      this.trackVideoDetail = data.data;
      this.contentProcessed.data = data.data.percentage;
    });
  }

  /**
   * Edit Tangram (Pathway)
   * @param pathwayId pathwayId
   */
  editTangram(pathwayId: any) {
    this.router.navigate(['edit-tangram', pathwayId]);
  }

  /**
   * Edit Tangram (Pathway) Video
   * @param pathwayId pathwayId
   */
  editTangramVideo(pathwayId: any) {
    this.router.navigate(['/edit-tangram-video', this.videoId]);
  }

  /**
   * Add Youtube Video
   * @param pathwayId pathwayId
   */
  addYoutubeVideo(pathwayId: any) {
    this.router.navigate(['/create-tangram'], { queryParams: { pathwayId: pathwayId } });
  }

  /**
   * On playlist click
   * @param video video to be played
   */
  onPlaylistClick(video) {
    console.log('video: ', video);
    if (!this.currentUser) {
      this.showLoginAlert()
      return;
    }

    // Check if pathway is private and user is not the creator
    if (video.pathway && video.pathway.isPrivate && this.currentUser && this.currentUser._id !== this.createdBy) {
      this.showPrivateAccessAlert();
      return;
    }

    // Check if pathway is invite-only
    if (video.pathway && video.pathway.isInviteOnly && this.currentUser && this.currentUser._id !== this.createdBy) {
      this.checkInviteOnlyAccess(video.pathway._id);
      if (!this.haveInviteOnlyAccess) {
        return;
      }
    }
    // Check if pathway is password protected using the pathway object
    if (video.pathway && video.pathway.isPasswordProtected && this.currentUser && this.currentUser._id !== this.createdBy) {
      this.pendingVideoAccess = video;
      this.openPasswordPrompt();
      return;
    }
    this.isDashboard = false;
    this.currentVideoDetail = video;
    this.videoId = video._id;
    this.getVideoDetail(video._id);
    this.pathwayDetail = { title: video.title, description: video.description, tagName: video.tag.name, videoURL: video.videoURL };
    // Reload tangram-level engagement data
    this.loadEngagementQuestions();
    this.loadPolls();
    this.loadPersonalNotes();
    this.loadCommentSummary();
    this.loadInteractionSummary();
    this.resetAiSuggestions();
    this.scheduleAiChatRender();
    this.scheduleLearningRoadmapRender();
  }

  /**
   * laod dashboard overview page
   */
  onDashboardClick() {
    this.isDashboard = true;
    this.currentVideoDetail = {};
    this.trackVideoDetail = {};
    this.videoId = '';
    this.getOverviewDetail();
    // Reload engagement data for tangram view (pathway-level)
    this.loadEngagementQuestions();
    this.loadPolls();
    this.loadPersonalNotes();
    this.resetCommentSummaryState();
    this.loadInteractionSummary();
    this.resetAiSuggestions();
    this.scheduleAiChatRender();
    this.scheduleLearningRoadmapRender();
  }

  private scheduleAiChatRender(delayMs: number = 700) {
    this.aiChatVisible = false;
    if (this.aiChatDelayTimer) {
      clearTimeout(this.aiChatDelayTimer);
    }
    this.aiChatDelayTimer = setTimeout(() => {
      this.aiChatVisible = true;
    }, delayMs);
  }

  private scheduleLearningRoadmapRender(delayMs: number = 700) {
    this.learningRoadmapVisible = false;
    if (this.learningRoadmapDelayTimer) {
      clearTimeout(this.learningRoadmapDelayTimer);
    }
    this.learningRoadmapDelayTimer = setTimeout(() => {
      this.learningRoadmapVisible = true;
    }, delayMs);
  }

  /** call footer event */
  callFooterCommonEvent() {
    this.commonService.raiseDashboardFooterEvent(this.isDashboard);
  }

  /**
  * Show video description modal
  */
  openSpotLightModal() {
    $("#spotlight").appendTo('body').modal('show');
  }

  /**
   * Called when update consumed content
   * @param data data to be tracked
   */
  onUpdateConsumedContent(data) {
    this.dashboardService.trackVideoWatch(data).subscribe((data: any) => {
      // Update consumed percentage
      const { percentage } = data.data;
      this.contentProcessed.data = percentage;
    });
  }

  /**
   * Load next video
   */
  loadNextVideo() {
    // Get current video position from playlist
    const currentVideoIndex = this.playlists.findIndex((playlist) => { return playlist._id == this.videoId });
    // Check video position available and video on next position is available then play next video
    if (currentVideoIndex != -1 && currentVideoIndex < (this.playlists.length - 1)) {
      this.onPlaylistClick(this.playlists[currentVideoIndex + 1]);
    }
  }

  /**
   * Handle change view subscription
   */
  handleChangeViewSubscription() {
    this.changeViewSubscription = this.commonService.onChangeView.subscribe((viewName: string) => {

      switch (viewName) {
        case 'dashboardOverview':
          this.showForumView = false;
          this.showForumQuestionView = false;
          this.showDashboardOverviewView = true;
          break;
        case 'forum':
          this.showForumView = true;
          this.showForumQuestionView = false;
          this.showDashboardOverviewView = false;
          break;
        case 'question':
          this.showForumQuestionView = true;
          this.showForumView = false;
          this.showDashboardOverviewView = false;
          break;
        default:
      }
    });
  }

  callback(entries, observer) {
    entries.forEach(entry => {
      // Each entry describes an intersection change for one observed
      // here you animate another element and do whatever you like
    });
  }

  /**
   * Update overview image url if given url is not valid
   * @param event
   */
  updateOverviewImageUrl(event, playlists) {
    if (playlists.length) {
      this.overviewImageUrl = this.playlists[0].thumbnail.mediumURL;
    } else {
      this.overviewImageUrl = "assets/img/videos/img6.png";
    }
  }
  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  openIframeExpand(modalContent: TemplateRef<any>) {
    this.modalService.open(modalContent, { centered: true, windowClass: 'iframe-modal', scrollable: true })
  }

  handleNext() {
    const videoList = this.playlists;
    let nextVideo;
    videoList.forEach((val, index) => {
      if (val._id == this.currentVideoDetail._id) {
        nextVideo = this.playlists[index + 1];
        if (index + 1 >= this.playlists.length) {
          nextVideo = this.playlists[0];
        }
      }
    })
    this.currentVideoDetail = nextVideo;
    this.onPlaylistClick(this.currentVideoDetail);
  }

  handlePrev() {
    const videoList = this.playlists;
    let nextVideo: any;
    videoList.forEach((val, index) => {
      if (val._id == this.currentVideoDetail._id) {
        nextVideo = this.playlists[index - 1];
        if (index - 1 < 0) {
          const length = this.playlists.length;
          nextVideo = this.playlists[length - 1];
        }
      }
    })
    this.currentVideoDetail = nextVideo;
    this.onPlaylistClick(this.currentVideoDetail);
  }

  handleDeleteMedia(mediaId) {
    let isLastMedia = false
    if (this.playlists.length == 1) {
      isLastMedia = true;
      if (!this.currentUser.subscriptionActive) {
        this.modalService.open(this.unlockPremiumModalContent, { centered: true, windowClass: 'unlock-premium' })
        return;
      }
    }
    const data = {
      mediaId: mediaId,
      isLastMedia: isLastMedia,
      pathwayId: this.currentPathwayId
    }

    this.dashboardService.deleteMedia(data).subscribe((res: any) => {
      if (res.success) {
        const pathwayId = this.currentPathwayId;
        this.dashboardService.getPathwayDetail(pathwayId).subscribe((data: any) => {
          this.thumbnailsList = [];
          const { totalVideos, totalDurationMIN, videos, } = data.data;
          this.playlists = [...videos];
          this.thumbnailsList = [...this.playlists]
          this.videosDuration = { totalVideo: totalVideos, totalVideoMinutes: totalDurationMIN };
          this.updateOverviewImageUrl(null, this.playlists)

          if (!this.playlists.length) {
            this.router.navigate(['/my-tangram']);
            return;
          }
        })
      }
    })
  }

  changeCommentDisable(event, modalContent: TemplateRef<any>) {
    if (!this.currentUser.subscriptionActive) {
      this.cd.detectChanges();
      this.modalService.open(modalContent, { centered: true, windowClass: 'unlock-premium' })
      setTimeout(() => {
        this.isCommentDisable = !this.isCommentDisable
      }, 0)
      return;
    }
    const data = {
      video_id: this.videoId,
      disableComment: this.isCommentDisable
    }
    this.dashboardService.disableCommenting(data).subscribe((response) => {
    })
  }

  getCuratorsCount() {
    this.authService.curatorsCount().subscribe((res: any) => {
      this.numberOfCurators = res.count;
    })
  }

  showLoginAlert() {
    this.alterMessage = `Login required — sign-up for free to join ${this.numberOfCurators} users on Tangramio.`
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' })
  }

  navigateToLogin() {
    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
  }

  /**
   * Zoom the iframe or image content by applying transform scale
   * @param factor - Zoom factor (1.2 for zoom in, 0.8 for zoom out)
   */
  zoomIframe(factor: number) {
    // Check if current content is an image
    if (this.isCurrentVideoImage()) {
      this.zoomImage(factor);
      return;
    }

    // Find the iframe element by ID
    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;

    if (iframe) {
      console.log('Iframe found:', iframe);
      console.log('Iframe src:', iframe.src);
      console.log('Iframe origin:', new URL(iframe.src).origin);
      console.log('Current page origin:', window.location.origin);

      try {
        // First try to access iframe content for images
        console.log('iframe.contentDocument: ', iframe.contentDocument);

        if (iframe.contentDocument) {
          const images = iframe.contentDocument.querySelectorAll('img');
          console.log(`Found ${images.length} images in iframe content`);

          if (images.length > 0) {
            // Zoom images inside iframe content
            this.zoomIframeImages(factor);
            return;
          }
        } else {
          console.log('iframe.contentDocument is null - likely due to CORS restrictions');
          console.log('This happens when iframe content is from a different domain');
        }

        // If no images found in content, check if iframe src is an image
        const iframeSrc = iframe.src;
        if (iframeSrc && this.isImageUrl(iframeSrc)) {
          console.log('Iframe src is an image, applying zoom to iframe container');
          this.zoomIframeContainer(factor);
          return;
        }

        // Fallback: try to zoom the iframe container
        console.log('No images found, falling back to container zoom');
        this.zoomIframeContainer(factor);

      } catch (error) {
        console.warn('Cannot access iframe content (CORS restriction):', error);
        // Fallback to container zoom if image zoom fails
        this.zoomIframeContainer(factor);
      }
    } else {
      console.warn('Iframe not found');
    }
  }

  /**
   * Check if a URL points to an image
   */
  private isImageUrl(url: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
    const lowerUrl = url.toLowerCase();
    return imageExtensions.some(ext => lowerUrl.includes(ext));
  }

  /**
   * Check if current videoURL is an image
   */
  isCurrentVideoImage(): boolean {
    if (!this.videoURL) return false;

    // Canvas photo URLs don't carry a file extension (they're /files/:id/download?verifier=...),
    // so fall back to the media's tag / title when the URL itself isn't enough.
    const tag: any = this.tag;
    if (tag) {
      if (tag.name === 'Photo') return true;
      if (Array.isArray(tag) && tag.some(function(t: any) { return t && t.name === 'Photo'; })) return true;
    }

    const title = this.currentVideoDetail && (this.currentVideoDetail as any).title;
    if (title && this.isImageUrl(String(title))) return true;

    // Extract the actual URL from SafeResourceUrl if needed
    const urlString = this.videoURL.toString();
    return this.isImageUrl(urlString);
  }

  /**
   * Zoom images inside iframe content
   */
  private zoomIframeImages(factor: number) {
    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;

    if (iframe && iframe.contentDocument) {
      // Calculate new image scale
      const newScale = this.imageScale * factor;

      // Update the image scale
      this.imageScale = newScale;

      // Find all images in the iframe
      const images = iframe.contentDocument.querySelectorAll('img');
      console.log(`Found ${images.length} images to zoom`);

      // Apply zoom to each image
      images.forEach((img, index) => {
        img.style.transform = `scale(${this.imageScale})`;
        img.style.transformOrigin = 'center center';
        img.style.transition = 'transform 0.3s ease';
        img.style.maxWidth = 'none'; // Allow images to exceed container
        img.style.maxHeight = 'none';

        console.log(`Image ${index + 1} zoomed to: ${this.imageScale}`);
      });

      // CSS handles scrolling automatically

      // Add zoomed class to video-player for button positioning
      this.updateVideoPlayerZoomClass();
    }
  }


  /**
   * Zoom the iframe container by applying transform scale
   * @param factor - Zoom factor (1.2 for zoom in, 0.8 for zoom out)
   */
  private zoomIframeContainer(factor: number) {
    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;

    if (!iframe) {
      console.warn('Iframe not found');
      return;
    }

    // Cache the base size once
    if (!(iframe as any).baseWidth) {
      (iframe as any).baseWidth = iframe.offsetWidth || iframe.clientWidth;
      (iframe as any).baseHeight = iframe.offsetHeight || iframe.clientHeight;
    }

    // No limits: scale can grow/shrink indefinitely
    this.iframeScale = this.iframeScale * factor;

    // If zoomed out from initial state (scale < 1), use transform scale for better centering
    if (this.iframeScale < 1) {
      // Remove explicit pixel sizing
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.maxWidth = 'none';
      iframe.style.maxHeight = 'none';

      // Use transform scale for zoomed out state
      iframe.style.transform = `scale(${this.iframeScale})`;
      iframe.style.transformOrigin = 'center center';
      iframe.style.transition = 'transform 0.3s ease';

      // Center the content when zoomed out
      const parent = iframe.parentElement as HTMLElement | null;
      if (parent) {
        parent.style.display = 'flex';
        parent.style.justifyContent = 'center';
        parent.style.alignItems = 'center';
        parent.style.overflow = 'hidden';
      }
    } else {
      // For zoomed in state (scale >= 1), use explicit pixel sizing
      iframe.style.transform = 'none';
      iframe.style.maxWidth = 'none';
      iframe.style.maxHeight = 'none';

      // Resize with explicit pixels so layout & scroll update
      const newWidth = (iframe as any).baseWidth * this.iframeScale;
      const newHeight = (iframe as any).baseHeight * this.iframeScale;
      iframe.style.width = `${newWidth}px`;
      iframe.style.height = `${newHeight}px`;
      iframe.style.transition = 'width 0.3s ease, height 0.3s ease';

      // Enable scrolling for zoomed in content
      const parent = iframe.parentElement as HTMLElement | null;
      if (parent) {
        parent.style.display = 'block';
        parent.style.justifyContent = 'unset';
        parent.style.alignItems = 'unset';
        parent.style.overflow = 'auto';
      }
    }

    this.updateVideoPlayerZoomClass();
  }

  /**
   * Add scroll indicators to show scrollable content
   */
  private addScrollIndicators(container: HTMLElement) {
    // Remove existing indicators first
    this.removeScrollIndicators(container);

    // Add scroll indicators
    const indicators = document.createElement('div');
    indicators.className = 'scroll-indicators';
    // indicators.innerHTML = `
    //   // <div class="scroll-hint scroll-hint-top">↑ Scroll up</div>
    //   // <div class="scroll-hint scroll-hint-bottom">↓ Scroll down</div>
    //   // <div class="scroll-hint scroll-hint-left">← Scroll left</div>
    //   // <div class="scroll-hint scroll-hint-right">→ Scroll right</div>
    // `;

    container.appendChild(indicators);
  }

  /**
   * Remove scroll indicators
   */
  private removeScrollIndicators(container: HTMLElement) {
    const indicators = container.querySelector('.scroll-indicators');
    if (indicators) {
      indicators.remove();
    }
  }

  /**
   * Zoom image content by applying transform scale with centralized effect
   * @param factor - Zoom factor (1.2 for zoom in, 0.8 for zoom out)
   */
  zoomImage(factor: number) {
    const image = document.getElementById('mainContentImage') as HTMLImageElement;

    if (!image) {
      console.warn('Image not found');
      return;
    }

    // Remove CSS caps that stop growth
    image.style.maxWidth = 'none';
    image.style.maxHeight = 'none';

    // Cache the base size once
    if (!(image as any).baseWidth) {
      (image as any).baseWidth = image.naturalWidth || image.width;
      (image as any).baseHeight = image.naturalHeight || image.height;
    }

    // No limits: scale can grow/shrink indefinitely
    this.imageScale = this.imageScale * factor;

    // Resize with explicit pixels so layout & scroll update
    const newWidth = (image as any).baseWidth * this.imageScale;
    const newHeight = (image as any).baseHeight * this.imageScale;
    image.style.width = `${newWidth}px`;
    image.style.height = `${newHeight}px`;
    image.style.transition = 'width 0.3s ease, height 0.3s ease';

    // Optional: ensure the parent can scroll (if not using #imageViewport)
    const parent = image.parentElement as HTMLElement | null;
    if (parent) parent.style.overflow = 'auto';

    this.updateVideoPlayerZoomClass();
  }



  /**
   * Reset the iframe or image zoom to original size
   */
  resetIframeZoom() {
    // Check if current content is an image
    if (this.isCurrentVideoImage()) {
      this.resetImageZoom();
      return;
    }

    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;

    if (iframe) {
      try {
        // Reset image scale
        this.imageScale = 1;

        // Reset iframe scale
        this.iframeScale = 1;

        // Reset iframe transform
        iframe.style.transform = 'scale(1)';
        iframe.style.transition = 'transform 0.3s ease';

        // Remove scrolling container
        iframe.style.overflow = 'hidden';

        // Remove scroll indicators
        this.removeScrollIndicators(iframe);

        // Update video player zoom class
        this.updateVideoPlayerZoomClass();

        console.log('Iframe zoom reset to original size');

      } catch (error) {
        console.warn('Error resetting iframe zoom:', error);
        // Fallback to container reset
        this.resetIframeContainerZoom();
      }
    }
  }

  /**
   * Fallback method to reset iframe container zoom
   */
  private resetIframeContainerZoom() {
    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;

    if (iframe) {
      // Reset iframe scale
      this.iframeScale = 1;

      // Reset iframe transform
      iframe.style.transform = 'scale(1)';
      iframe.style.transition = 'transform 0.3s ease';

      // Ensure iframe fits the screen properly
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';

      // Remove scrolling container
      iframe.style.overflow = 'hidden';

      // Remove scroll indicators
      this.removeScrollIndicators(iframe);

      // Update video player zoom class
      this.updateVideoPlayerZoomClass();

      console.log('Iframe container zoom reset to original size with proper screen fitting');
    }
  }

  /**
   * Reset image zoom to original size maintaining original view
   */
  resetImageZoom() {
    this.imageScale = 1;
    const image = document.getElementById('mainContentImage') as HTMLImageElement;

    if (image) {
      // Simple reset - let CSS handle the rest
      image.style.transform = 'scale(1)';
      image.style.transition = 'transform 0.3s ease';

      console.log('Image zoom reset to original size - CSS handles positioning automatically');
    }

    // Also reset any images inside iframe content
    const iframe = document.getElementById('mainContentIframe') as HTMLIFrameElement;
    if (iframe && iframe.contentDocument) {
      iframe.contentDocument.querySelectorAll('img').forEach(img => {
        img.style.transform = 'scale(1)';
        img.style.transition = 'transform 0.3s ease';
      });
      console.log('Iframe images zoom reset to original size');
    }
  }

  /**
   * Update video player zoom class for button positioning
   */
  private updateVideoPlayerZoomClass() {
    const videoPlayer = document.querySelector('.video-player') as HTMLElement;

    if (videoPlayer) {
      // Check if either image or iframe is zoomed
      const isZoomed = this.imageScale !== 1 || this.iframeScale !== 1;

      if (isZoomed) {
        videoPlayer.classList.add('zoomed');
        console.log('Added zoomed class - buttons will stick to viewport');
      } else {
        videoPlayer.classList.remove('zoomed');
        console.log('Removed zoomed class - buttons return to normal positioning');
      }
    }
  }


  /**
   * Zoom the expanded iframe or image container
   */
  zoomExpandedIframe(factor: number) {
    // Check if current content is an image
    if (this.isCurrentVideoImage()) {
      this.zoomExpandedImage(factor);
      return;
    }

    const iframe = document.getElementById('expandedIframe') as HTMLIFrameElement;

    if (iframe && iframe.contentDocument) {
      try {
        // Calculate new image scale
        const newScale = this.expandedImageScale * factor;

        // Update the image scale
        this.expandedImageScale = newScale;

        // Find all images in the iframe
        const images = iframe.contentDocument.querySelectorAll('img');
        console.log(`Expanded iframe: Found ${images.length} images to zoom`);

        // Apply zoom to each image
        images.forEach((img, index) => {
          img.style.transform = `scale(${this.expandedImageScale})`;
          img.style.transformOrigin = 'center center';
          img.style.transition = 'transform 0.3s ease';
          img.style.maxWidth = 'none';
          img.style.maxHeight = 'none';
        });

        console.log(`Expanded iframe: ${images.length} images zoomed to: ${this.expandedImageScale}`);

      } catch (error) {
        console.warn('Cannot access expanded iframe content (CORS restriction):', error);
        // Fallback to container zoom
        this.zoomExpandedIframeContainer(factor);
      }
    } else {
      console.warn('Expanded iframe not found or content not accessible');
      // Fallback to container zoom
      this.zoomExpandedIframeContainer(factor);
    }
  }

  /**
   * Zoom expanded image content
   */
  zoomExpandedImage(factor: number) {
    const image = document.getElementById('expandedImage') as HTMLImageElement;
    if (!image) {
      console.warn('Expanded image not found');
      return;
    }

    // Remove CSS caps that stop growth (same as main zoom)
    image.style.maxWidth = 'none';
    image.style.maxHeight = 'none';
    image.style.display = 'block';

    // Cache the base size once (store on the element so it’s independent of main image)
    const anyImg: any = image;
    if (!anyImg.baseWidth) {
      anyImg.baseWidth = image.naturalWidth || image.width;
      anyImg.baseHeight = image.naturalHeight || image.height;
      if (!anyImg.baseWidth || !anyImg.baseHeight) {
        const cs = window.getComputedStyle(image);
        const w = parseFloat(cs.width || '0') || 1;
        const h = parseFloat(cs.height || '0') || 1;
        if (!anyImg.baseWidth) anyImg.baseWidth = w;
        if (!anyImg.baseHeight) anyImg.baseHeight = h;
      }
    }

    // No limits: scale can grow/shrink indefinitely (same behavior)
    this.expandedImageScale = (this.expandedImageScale || 1) * factor;

    // Resize with explicit pixels so layout & scroll update
    const newWidth = anyImg.baseWidth * this.expandedImageScale;
    const newHeight = anyImg.baseHeight * this.expandedImageScale;
    image.style.width = newWidth + 'px';
    image.style.height = newHeight + 'px';
    image.style.transition = 'width 0.3s ease, height 0.3s ease';

    // Ensure the parent can scroll
    const parent = image.parentElement as HTMLElement | null;
    if (parent) parent.style.overflow = 'auto';

    // Keep your UI in sync
    if (typeof (this as any).updateExpandedModalZoomClass === 'function') {
      this.updateExpandedModalZoomClass();
    }

    console.log('Expanded image zoomed: scale=' + this.expandedImageScale + ', size=' + newWidth + 'x' + newHeight);
  }


  /**
   * Fallback method to zoom the expanded iframe container
   */
  private zoomExpandedIframeContainer(factor: number) {
    const iframe = document.getElementById('expandedIframe') as HTMLIFrameElement;

    if (!iframe) {
      console.warn('Expanded iframe not found');
      return;
    }

    // Cache the base size once
    if (!(iframe as any).baseWidth) {
      (iframe as any).baseWidth = iframe.offsetWidth || iframe.clientWidth;
      (iframe as any).baseHeight = iframe.offsetHeight || iframe.clientHeight;
    }

    // Prevent further zooming out if already zoomed out (scale < 1)
    // if (this.expandedIframeScale < 1 && factor < 1) {
    //   return;
    // }

    // No limits: scale can grow/shrink indefinitely
    this.expandedIframeScale = this.expandedIframeScale * factor;

    // If zoomed out from initial state (scale < 1), use transform scale for better centering
    if (this.expandedIframeScale < 1) {
      // Remove explicit pixel sizing
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.maxWidth = 'none';
      iframe.style.maxHeight = 'none';

      // Use transform scale for zoomed out state
      iframe.style.transform = `scale(${this.expandedIframeScale})`;
      iframe.style.transformOrigin = 'center center';
      iframe.style.transition = 'transform 0.3s ease';

      // Center the content when zoomed out
      const parent = iframe.parentElement as HTMLElement | null;
      if (parent) {
        parent.style.display = 'flex';
        parent.style.justifyContent = 'center';
        parent.style.alignItems = 'center';
        parent.style.overflow = 'hidden';
      }
    } else {
      // For zoomed in state (scale >= 1), use explicit pixel sizing
      iframe.style.transform = 'none';
      iframe.style.maxWidth = 'none';
      iframe.style.maxHeight = 'none';

      // Resize with explicit pixels so layout & scroll update
      const newWidth = (iframe as any).baseWidth * this.expandedIframeScale;
      const newHeight = (iframe as any).baseHeight * this.expandedIframeScale;
      iframe.style.width = `${newWidth}px`;
      iframe.style.height = `${newHeight}px`;
      iframe.style.transition = 'width 0.3s ease, height 0.3s ease';

      // Enable scrolling for zoomed in content
      const parent = iframe.parentElement as HTMLElement | null;
      if (parent) {
        parent.style.display = 'block';
        parent.style.justifyContent = 'unset';
        parent.style.alignItems = 'unset';
        parent.style.overflow = 'auto';
      }
    }

    this.updateExpandedModalZoomClass();
  }

  /**
   * Zoom images inside the expanded iframe
   */
  zoomExpandedImages(factor: number) {
    const iframe = document.getElementById('expandedIframe') as HTMLIFrameElement;

    if (iframe && iframe.contentDocument) {
      try {
        const newScale = this.expandedImageScale * factor;

        // Check image zoom limits
        // Removed image zoom limits to allow infinite zoom

        this.expandedImageScale = newScale;
        const images = iframe.contentDocument.querySelectorAll('img');

        images.forEach((img, index) => {
          img.style.transform = `scale(${this.expandedImageScale})`;
          img.style.transformOrigin = 'center center';
          img.style.transition = 'transform 0.3s ease';
          img.style.maxWidth = 'none';
          img.style.maxHeight = 'none';
        });

        console.log(`Expanded iframe: ${images.length} images zoomed to: ${this.expandedImageScale}`);

      } catch (error) {
        console.warn('Cannot access expanded iframe content (CORS restriction):', error);
        this.zoomExpandedIframe(factor);
      }
    } else {
      console.warn('Expanded iframe not found or content not accessible');
      this.zoomExpandedIframe(factor);
    }
  }

  /**
   * Reset expanded iframe or image zoom
   */
  resetExpandedIframeZoom() {
    // Check if current content is an image
    if (this.isCurrentVideoImage()) {
      this.resetExpandedImageZoom();
      return;
    }

    // Reset image zoom
    this.expandedImageScale = 1;
    const iframe = document.getElementById('expandedIframe') as HTMLIFrameElement;

    if (iframe && iframe.contentDocument) {
      try {
        iframe.contentDocument.querySelectorAll('img').forEach(img => {
          img.style.transform = 'scale(1)';
          img.style.transition = 'transform 0.3s ease';
          img.style.maxWidth = 'none';
          img.style.maxHeight = 'none';
        });
        console.log('Expanded iframe image zoom reset');
      } catch (error) {
        console.warn('Cannot access expanded iframe content for reset:', error);
        // Fallback to container reset
        this.resetExpandedIframeContainerZoom();
      }
    } else {
      // Fallback to container reset
      this.resetExpandedIframeContainerZoom();
    }
  }

  /**
   * Reset expanded image zoom
   */
  resetExpandedImageZoom() {
    this.expandedImageScale = 1;
    const image = document.getElementById('expandedImage') as HTMLImageElement;

    if (image) {
      // Reset to original view
      image.style.transform = 'scale(1)';
      image.style.transition = 'transform 0.3s ease';

      // Reset positioning
      image.style.position = 'static';
      image.style.left = 'auto';
      image.style.top = 'auto';
      image.style.marginLeft = 'auto';
      image.style.marginTop = 'auto';

      console.log('Expanded image zoom reset to original size maintaining original view');
    }
  }

  /**
   * Fallback method to reset expanded iframe container zoom
   */
  private resetExpandedIframeContainerZoom() {
    this.expandedIframeScale = 1;
    const iframe = document.getElementById('expandedIframe') as HTMLIFrameElement;

    if (iframe) {
      // Find the expanded iframe container
      const iframeContainer = iframe.closest('.expanded-iframe-container') as HTMLElement;

      if (iframeContainer) {
        iframe.style.transform = 'scale(1)';
        iframe.style.transition = 'transform 0.3s ease';

        // Ensure iframe fits the screen properly
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';

        // Reset container scrolling
        iframeContainer.style.overflow = 'hidden';
        iframeContainer.classList.remove('zoomed');

        console.log('Expanded iframe container zoom reset with proper screen fitting');
      }
    }
  }


  /**
   * Open info link in new tab
   */
  openInfoLink() {
    if (this.currentVideoDetail && this.currentVideoDetail.youtubeVideoId) {
      window.open(this.currentVideoDetail.youtubeVideoId, '_blank');
    }
  }

  /**
   * Add scrolling container when expanded iframe is zoomed in - same as main iframe
   */
  private addExpandedIframeScrollingContainer(iframe: HTMLIFrameElement) {
    // Check if iframe parent needs scrolling
    const iframeParent = iframe.parentElement;

    if (iframeParent && this.expandedIframeScale > 1) {
      // Add overflow scroll when zoomed in
      iframeParent.style.overflow = 'auto';
      iframeParent.style.overflowX = 'auto';
      iframeParent.style.overflowY = 'auto';
      (iframeParent.style as any).webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      iframeParent.style.maxHeight = '100%';
      iframeParent.style.maxWidth = '100%';

      // Add zoomed class to modal container for button positioning
      const modalContainer = iframeParent.closest('.modal-iframe-container');
      if (modalContainer) {
        modalContainer.classList.add('zoomed');
      }

      // Add scroll indicators
      this.addScrollIndicators(iframeParent);
    } else if (iframeParent && this.expandedIframeScale <= 1) {
      // Remove overflow scroll when zoomed out
      iframeParent.style.overflow = 'hidden';
      iframeParent.style.overflowX = 'hidden';
      iframeParent.style.overflowY = 'hidden';
      (iframeParent.style as any).webkitOverflowScrolling = 'auto';
      iframeParent.style.maxHeight = 'none';
      iframeParent.style.maxWidth = 'none';

      // Remove zoomed class from modal container
      const modalContainer = iframeParent.closest('.modal-iframe-container');
      if (modalContainer) {
        modalContainer.classList.remove('zoomed');
      }

      // Remove scroll indicators
      this.removeScrollIndicators(iframeParent);
    }
  }

  /**
   * Add scrolling container for expanded images
   */
  private addExpandedImageScrolling(image: HTMLImageElement) {
    const imageParent = image.parentElement;
    if (imageParent && this.expandedImageScale > 1) {
      // Enable scrolling for zoomed content
      imageParent.style.overflow = 'auto';
      imageParent.style.overflowX = 'auto';
      imageParent.style.overflowY = 'auto';
      (imageParent.style as any).webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      imageParent.classList.add('zoomed');

      // Ensure the container can scroll in all directions
      imageParent.style.maxWidth = '100%';
      imageParent.style.maxHeight = '100%';

      this.addScrollIndicators(imageParent); // Add scroll indicators for images
    } else if (imageParent && this.expandedImageScale <= 1) {
      // Reset container styles when not zoomed
      imageParent.style.overflow = 'hidden';
      imageParent.style.overflowX = 'hidden';
      imageParent.style.overflowY = 'hidden';
      (imageParent.style as any).webkitOverflowScrolling = 'auto';
      imageParent.style.maxWidth = 'none';
      imageParent.style.maxHeight = 'none';
      imageParent.classList.remove('zoomed');
      this.removeScrollIndicators(imageParent);
    }
  }

  /**
   * Update the expanded modal container class based on zoom state
   */
  private updateExpandedModalZoomClass() {
    const modalContainer = document.querySelector('.modal-iframe-container') as HTMLElement;

    if (modalContainer) {
      // Check if expanded iframe or image is zoomed
      const isZoomed = this.expandedIframeScale !== 1 || this.expandedImageScale !== 1;

      if (isZoomed) {
        modalContainer.classList.add('zoomed');
        console.log('Added zoomed class to expanded modal - scrolling enabled');
      } else {
        modalContainer.classList.remove('zoomed');
        console.log('Removed zoomed class from expanded modal - scrolling disabled');
      }
    }
  }

  /**
   * Open password prompt modal
   */
  openPasswordPrompt() {
    this.passwordPromptError = '';
    this.pathwayPassword = '';
    this.showPassword = false; // Reset password visibility
    this.currentModal = this.modalService.open(this.passwordPromptModalContent, { centered: true });
  }

  /**
   * Toggle password visibility in password prompt
   */
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  /**
   * Handle close action - switch to dashboard main page
   */
  handleClose() {
    if (this.currentModal) {
      this.currentModal.close('Cancel');
      this.router.navigate(['/dashboard', this.pathwayId]);
    }
    if (this.isDashboard) {
      return;
    }
    // Switch to dashboard view instead of navigation
    this.isDashboard = true;
    this.currentVideoDetail = {};
    this.trackVideoDetail = {};
    // this.getOverviewDetail();
    // if(this.videoId){
    //   this.router.navigate(['/dashboard', this.pathwayId]);
    //   return;
    // }
  }

  /**
   * Validate password for pathway access
   */
  validatePassword(modal: any) {
    if (!this.pathwayPassword) {
      this.passwordPromptError = 'Please enter a password';
      return;
    }

    if (!this.pendingVideoAccess) {
      this.passwordPromptError = 'No video access pending';
      return;
    }

    // Call password validation API 
    const pathwayId = this.pendingVideoAccess.pathwayId || (this.pendingVideoAccess.pathway && this.pendingVideoAccess.pathway._id);
    this.dashboardService.validatePathwayPassword(pathwayId, this.pathwayPassword)
      .subscribe(
        (response: any) => {
          if (response.success) {
            // Password is valid, proceed with video access
            modal.close('Password Validated');

            // Clear password prompt state
            this.passwordPromptError = '';
            this.pathwayPassword = '';
            this.currentModal = null;
            this.showPasswordAlert = false

            // Switch to video view and load video details
            this.isDashboard = false;
            this.currentVideoDetail = this.pendingVideoAccess;
            this.videoId = this.pendingVideoAccess._id;
            this.getVideoDetail(this.pendingVideoAccess._id);
            this.pathwayDetail = {
              title: this.pendingVideoAccess.title,
              description: this.pendingVideoAccess.description,
              tagName: this.pendingVideoAccess.tag.name,
              videoURL: this.pendingVideoAccess.videoURL
            };

            // Reload notes for the new video
            this.loadPersonalNotes();

            // Clear pending access
            this.pendingVideoAccess = null;
          } else {
            this.passwordPromptError = response.message || 'Invalid password';
          }
        },
        (error) => {
          this.passwordPromptError = (error.error && error.error.message) || 'Error validating password';
        }
      );
  }

  /**
   * Show private access alert
   */
  showPrivateAccessAlert() {
    this.alterMessage = 'This Tangram is private and only accessible by the creator.';
    this.showSuccessButton = false;
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' } as NgbModalOptions);
    // Switch back to dashboard view
    this.isDashboard = true;
    // this.currentVideoDetail = {};
    // this.trackVideoDetail = {};
    // this.getOverviewDetail();    
  }
  // Redirect to home page after 3 seconds if user is not the creator

  navigateToHome() {
    // this.router.navigate(['dashboard', this.pathwayId]);
    this.showSuccessButton = true;
  }

  /**
   * Check invite-only access for a pathway
   */
  checkInviteOnlyAccess(pathwayId: string): void {
    this.dashboardService.checkInviteAccess(pathwayId).subscribe(
      (response: any) => {
        if (response.success) {
          if (!response.hasAccess) {
            this.showInviteOnlyAccessAlert(response.tangramTitle);
            this.haveInviteOnlyAccess = false;
            return;
          }
          this.haveInviteOnlyAccess = true;
          this.canManage = response.accessType === 'editor';
        }
      });
  }

  /**
   * Show invite-only access alert
   */
  showInviteOnlyAccessAlert(tangramTitle?: string) {
    const title = tangramTitle ? `"${tangramTitle}"` : 'This Tangram';
    this.alterMessage = `${title} is invite-only and you do not have access to it.`;
    this.showSuccessButton = false;
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' } as NgbModalOptions);
    // Switch back to dashboard view
    this.isDashboard = true;
    this.currentVideoDetail = {};
    this.trackVideoDetail = {};
    // this.getOverviewDetail();
  }

  // ==================== Completion ====================

  loadCompletionData() {
    if (!this.currentUser || !this.pathwayId) return;
    this.dashboardService.getMediaCompletions(this.pathwayId).subscribe((response: any) => {
      if (response.success) {
        this.completedVideoIds = response.data.completedVideoIds || [];
        this.completionPercentage = response.data.completionPercentage || 0;
      }
    });
  }

  onToggleMediaCompletion(event: { videoId: string, isCompleted: boolean }) {
    // Optimistically update local state
    if (event.isCompleted) {
      if (!this.completedVideoIds.includes(event.videoId)) {
        this.completedVideoIds = [...this.completedVideoIds, event.videoId];
      }
    } else {
      this.completedVideoIds = this.completedVideoIds.filter(id => id !== event.videoId);
    }

    this.dashboardService.toggleMediaCompletion(event.videoId, this.pathwayId, event.isCompleted)
      .subscribe((response: any) => {
        if (response.success) {
          this.completedVideoIds = response.data.completedVideoIds || [];
          this.completionPercentage = response.data.completionPercentage || 0;
        }
      }, () => {
        // Revert on error
        this.loadCompletionData();
        this.toasterService.error('Failed to update media completion', 'Error');
      });
  }

  toggleCompleted() {
    const newStatus = !this.isCompleted;
    this.dashboardService.togglePathwayCompletion(this.pathwayId, newStatus).subscribe((response: any) => {
      if (response.success) {
        this.isCompleted = newStatus;
        this.toasterService.success(
          newStatus ? 'Tangram marked as complete!' : 'Tangram marked as incomplete.',
          'Success'
        );
      }
    }, () => {
      this.toasterService.error('Failed to update completion status', 'Error');
    });
  }

  // ==================== Personal Notes ====================

  toggleNotes() {
    this.isNotesExpanded = !this.isNotesExpanded;
  }

  loadPersonalNotes() {
    if (!this.currentUser || !this.pathwayId) return;
    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.getNotes(this.pathwayId, videoId).subscribe((response: any) => {
      if (response.success) {
        this.personalNotes = response.data;
      }
    });
  }

  saveNote() {
    if (!this.newNoteText.trim()) return;
    if (!this.currentUser.subscriptionActive) {
      this.modalService.open(this.unlockPremiumModalContent, { centered: true, windowClass: 'unlock-premium' })
      return;
    }
    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.createNote(this.pathwayId, this.newNoteText.trim(), this.isNotePrivate, videoId).subscribe((response: any) => {
      if (response.success) {
        this.personalNotes.unshift(response.data);
        this.newNoteText = '';
        this.isNotePrivate = false;
        // this.toasterService.success('Note saved successfully!', 'Success');
      }
    }, () => {
      this.toasterService.error('Failed to save note', 'Error');
    });
  }

  /** Called by <tangram-ai-chat> after an AI response is persisted as a private note. */
  onAiNoteSaved(note: any) {
    if (!note) return;
    // AI-saved notes are always markdown — guarantee the flag is set so the
    // notes list renders with formatting even if the backend response omits it.
    note.isMarkdown = true;
    // Ensure the current user shows up as the note author without a re-fetch.
    if (!note.userId && this.currentUser) {
      note.userId = {
        _id: this.currentUser._id,
        firstName: this.currentUser.firstName,
        lastName: this.currentUser.lastName,
      };
    }
    this.personalNotes = [note, ...this.personalNotes];
    // Expand the notes panel so the user can see their new entry.
    this.isNotesExpanded = true;
  }

  /** Render a note body as HTML when it was saved with markdown (AI responses). */
  formatNoteBody(text: string): string {
    return formatMarkdown(text);
  }

  deleteNote(noteId: string) {
    const note = this.personalNotes.find(n => n._id === noteId);
    if (!note) return;
    const label = !note.isPrivate ? 'comment' : 'note';
    this.pendingDeleteItem = note;
    this.pendingDeleteType = 'note';
    this.alterMessage = `Do you want to delete this ${label}?`;
    this.modalService.open(this.deleteConfirmContent, { centered: true, windowClass: 'unlock-premium' });
  }

  // ==================== Questions ====================

  loadEngagementQuestions() {
    if (!this.currentUser || !this.pathwayId) return;
    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.getEngagementQuestions(this.pathwayId, videoId).subscribe((response: any) => {
      if (response.success) {
        this.questions = response.data.map((q: any) => ({
          ...q,
          answers: (q.answers || []).map((a: any) => ({
            ...a,
            user: a.userId ? ((a.userId.firstName ? a.userId.firstName + (a.userId.lastName ? ' ' + a.userId.lastName : '') : a.userId.screenName) || 'User') : 'User'
          }))
        }));
        this.loadInteractionSummary();
      }
    });
  }

  toggleQuestionsSection() {
    this.isQuestionsExpanded = !this.isQuestionsExpanded;
  }

  toggleQuestion(questionId: string) {
    this.expandedQuestionId = this.expandedQuestionId === questionId ? '' : questionId;
  }

  togglePollsSection() {
    this.isPollsExpanded = !this.isPollsExpanded;
  }

  togglePoll(pollId: string) {
    this.expandedPollId = this.expandedPollId === pollId ? '' : pollId;
  }

  openQuestionModal() {
    this.showQuestionModal = true;
    this.editingQuestionId = '';
    this.newQuestionText = '';
    this.newQuestionType = 'Open-Ended';
    this.newQuestionOptions = ['', ''];
  }

  /**
   * Open the question modal pre-filled with an existing question so the user
   * can refine it (e.g. after accepting an AI-suggested question).
   */
  openEditQuestionModal(question: any) {
    this.showQuestionModal = true;
    this.editingQuestionId = question._id;
    this.newQuestionText = question.text || '';
    this.newQuestionType = question.type || 'Open-Ended';
    if (this.newQuestionType === 'Multiple Choice') {
      const opts = Array.isArray(question.options) ? [...question.options] : [];
      while (opts.length < 2) opts.push('');
      this.newQuestionOptions = opts;
    } else {
      this.newQuestionOptions = ['', ''];
    }
  }

  closeQuestionModal() {
    this.showQuestionModal = false;
    this.editingQuestionId = '';
  }

  addQuestionOption() {
    this.newQuestionOptions.push('');
  }

  removeQuestionOption(index: number) {
    if (this.newQuestionOptions.length > 2) {
      this.newQuestionOptions.splice(index, 1);
    }
  }

  addQuestion() {
    if (!this.newQuestionText.trim()) return;
    if (!this.currentUser.subscriptionActive) {
      this.modalService.open(this.unlockPremiumModalContent, { centered: true, windowClass: 'unlock-premium' })
      return;
    }
    if (this.newQuestionType === 'Multiple Choice') {
      const validOptions = this.newQuestionOptions.filter(o => o.trim());
      if (validOptions.length < 2) {
        this.toasterService.warning('Please provide at least 2 options for Multiple Choice.', 'Warning');
        return;
      }
    }
    const options = this.newQuestionType === 'Multiple Choice'
      ? this.newQuestionOptions.filter(o => o.trim()).map(o => o.trim())
      : undefined;

    // Edit mode — PUT update instead of POST create
    if (this.editingQuestionId) {
      this.dashboardService.updateEngagementQuestion(this.editingQuestionId, this.newQuestionText.trim(), this.newQuestionType, options).subscribe((response: any) => {
        if (response.success) {
          const idx = this.questions.findIndex(q => q._id === this.editingQuestionId);
          if (idx !== -1) {
            const prevAnswers = this.questions[idx].answers || [];
            this.questions[idx] = { ...response.data, answers: prevAnswers };
          }
          this.toasterService.success('Question updated', 'Success');
          this.closeQuestionModal();
        }
      }, () => {
        this.toasterService.error('Failed to update question', 'Error');
      });
      return;
    }

    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.createEngagementQuestion(this.pathwayId, this.newQuestionText.trim(), this.newQuestionType, videoId, options).subscribe((response: any) => {
      if (response.success) {
        response.data.answers = [];
        this.questions.unshift(response.data);
        this.showQuestionModal = false;
        this.newQuestionText = '';
        this.newQuestionOptions = ['', ''];
      }
    }, () => {
      this.toasterService.error('Failed to add question', 'Error');
    });
  }

  submitAnswer(question: any, answerText: string) {
    if (!answerText.trim()) return;
    this.dashboardService.submitEngagementAnswer(question._id, answerText.trim()).subscribe((response: any) => {
      if (response.success) {
        // Refresh question answers from response
        const updated = response.data;
        question.answers = (updated.answers || []).map((a: any) => ({
          ...a,
          user: a.userId ? (a.userId.firstName || a.userId.screenName || 'User') : 'User'
        }));
        this.toasterService.success('Answer submitted!', 'Success');
      }
    }, () => {
      this.toasterService.error('Failed to submit answer', 'Error');
    });
  }

  canDeleteQuestion(question: any): boolean {
    if (!this.currentUser) return false;
    if (this.currentUser.role === 'SUPER_USER') return true;
    if (this.currentUser._id === this.createdBy) return true;
    if (question.userId && question.userId._id === this.currentUser._id) return true;
    return false;
  }

  deleteQuestion(question: any) {
    this.pendingDeleteItem = question;
    this.pendingDeleteType = 'question';
    this.alterMessage = 'Do you want to delete this question?';
    this.modalService.open(this.deleteConfirmContent, { centered: true, windowClass: 'unlock-premium' });
  }

  // ==================== Polls ====================

  loadPolls() {
    if (!this.currentUser || !this.pathwayId) return;
    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.getPolls(this.pathwayId, videoId).subscribe((response: any) => {
      if (response.success) {
        this.polls = response.data.map((p: any) => ({
          ...p,
          selectedOptions: p.selectedOptions || []
        }));
        this.loadInteractionSummary();
      }
    });
  }

  loadInteractionSummary(provider: 'gemini' | 'openai' = 'gemini') {
    if (!this.canManage || !this.pathwayId) {
      this.interactionSummary = null;
      this.interactionSummaryError = '';
      this.interactionSummaryLoading = false;
      return;
    }
    const fallback = this.buildFallbackInteractionSummary();
    this.interactionSummaryLoading = true;
    this.interactionSummaryError = '';
    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.aiService.getInteractionSummary({
      pathwayId: this.pathwayId,
      videoId,
      questions: this.questions || [],
      polls: this.polls || [],
      commentCount: this.publicCommentCount || 0
    }, provider).subscribe((summary) => {
      this.interactionSummaryLoading = false;
      if (summary) {
        this.interactionSummary = summary;
        return;
      }
      this.interactionSummary = fallback;
      this.interactionSummaryError = 'Showing fallback interaction summary.';
    }, () => {
      this.interactionSummaryLoading = false;
      this.interactionSummary = fallback;
      this.interactionSummaryError = 'Showing fallback interaction summary.';
    });
  }

  loadCommentSummary(provider: 'gemini' | 'openai' = 'gemini') {
    if (this.isDashboard || !this.pathwayId || !this.videoId) {
      this.resetCommentSummaryState();
      return;
    }
    this.commentSummaryLoading = true;
    this.commentSummaryError = '';
    const videoData = {
      videoId: this.videoId,
      type: 'all',
      page: 1,
      limit: 50,
      isFlagged: false,
      pathwayId: this.pathwayId,
      timeSlot: 0
    };
    this.dashboardService.getVideoCommentsList(videoData, 'all', 'public').subscribe((res: any) => {
      const comments = this.extractCommentTexts((res && res.data) || []);
      this.publicCommentCount = Number((res && res.totalCount) || comments.length || 0);
      if (!comments.length) {
        this.commentSummaryLoading = false;
        this.commentSummary = null;
        this.commentSummaryError = 'No public comments available for summary yet.';
        this.loadInteractionSummary();
        return;
      }
      const fallback = this.buildFallbackCommentSummary(comments);
      this.aiService.getCommentSummary({
        pathwayId: this.pathwayId,
        videoId: this.videoId,
        comments
      }, provider).subscribe((summary) => {
        this.commentSummaryLoading = false;
        if (summary) {
          this.commentSummary = summary;
          this.commentSummaryError = '';
        } else {
          this.commentSummary = fallback;
          this.commentSummaryError = 'Showing fallback comment summary.';
        }
        this.loadInteractionSummary();
      }, () => {
        this.commentSummaryLoading = false;
        this.commentSummary = fallback;
        this.commentSummaryError = 'Showing fallback comment summary.';
        this.loadInteractionSummary();
      });
    }, () => {
      this.commentSummaryLoading = false;
      this.commentSummary = null;
      this.commentSummaryError = 'Unable to load public comments for summary.';
      this.loadInteractionSummary();
    });
  }

  private extractCommentTexts(comments: any[]): string[] {
    const texts: string[] = [];
    (comments || []).forEach((comment: any) => {
      if (comment && comment.text) {
        texts.push(String(comment.text).trim());
      }
      ((comment && comment.reply) || []).forEach((reply: any) => {
        if (reply && reply.text) {
          texts.push(String(reply.text).trim());
        }
      });
    });
    return texts.filter((text) => !!text);
  }

  private buildFallbackInteractionSummary(): InteractionSummaryModel {
    const questionCount = (this.questions && this.questions.length) || 0;
    const pollCount = (this.polls && this.polls.length) || 0;
    const commentCount = this.publicCommentCount || 0;
    const highlights: string[] = [];
    if (questionCount > 0) {
      highlights.push(`${questionCount} learner question${questionCount > 1 ? 's' : ''} captured.`);
    }
    if (pollCount > 0) {
      highlights.push(`${pollCount} poll${pollCount > 1 ? 's' : ''} created for engagement.`);
    }
    if (commentCount > 0) {
      highlights.push(`${commentCount} public comment${commentCount > 1 ? 's' : ''} active in discussion.`);
    }
    return {
      summary: 'Interaction activity is based on questions, polls, and allowed public discussion only. Use this snapshot to monitor where learners need support.',
      highlights,
      totals: {
        questions: questionCount,
        polls: pollCount,
        comments: commentCount
      }
    };
  }

  private buildFallbackCommentSummary(comments: string[]): CommentSummaryModel {
    const sentiment = this.estimateSentiment(comments);
    const topPoints = comments.slice(0, 3).map((text) => text.length > 110 ? `${text.slice(0, 107)}...` : text);
    return {
      summary: `Discussion is ${sentiment} overall across ${comments.length} public comment${comments.length > 1 ? 's' : ''}. Learners are focusing on practical questions and clarifications around this media.`,
      sentiment,
      keyTakeaways: topPoints
    };
  }

  private estimateSentiment(comments: string[]): 'positive' | 'neutral' | 'negative' {
    const positiveWords = ['good', 'great', 'helpful', 'clear', 'love', 'excellent', 'useful', 'thanks'];
    const negativeWords = ['confusing', 'hard', 'bad', 'unclear', 'difficult', 'issue', 'problem', 'stuck'];
    let score = 0;
    comments.forEach((text) => {
      const normalized = text.toLowerCase();
      positiveWords.forEach((word) => {
        if (normalized.includes(word)) {
          score += 1;
        }
      });
      negativeWords.forEach((word) => {
        if (normalized.includes(word)) {
          score -= 1;
        }
      });
    });
    if (score > 0) {
      return 'positive';
    }
    if (score < 0) {
      return 'negative';
    }
    return 'neutral';
  }

  private resetCommentSummaryState() {
    this.commentSummary = null;
    this.commentSummaryError = '';
    this.commentSummaryLoading = false;
    this.publicCommentCount = 0;
  }

  openPollModal() {
    this.showPollModal = true;
    this.editingPollId = '';
    this.newPollQuestion = '';
    this.pollOptions = ['', ''];
    this.allowMultipleSelections = false;
  }

  /**
   * Open the poll modal pre-filled with an existing poll's values so the
   * creator can tweak wording or option labels. Saving resets votes.
   */
  openEditPollModal(poll: any) {
    this.showPollModal = true;
    this.editingPollId = poll._id;
    this.newPollQuestion = poll.question || '';
    const opts = Array.isArray(poll.options) ? poll.options.map((o: any) => (typeof o === 'string' ? o : o.text || '')) : [];
    while (opts.length < 2) opts.push('');
    this.pollOptions = opts;
    this.allowMultipleSelections = !!poll.allowMultiple;
  }

  closePollModal() {
    this.showPollModal = false;
    this.editingPollId = '';
  }

  addPollOption() {
    if (this.pollOptions.length < 6) {
      this.pollOptions.push('');
    }
  }

  removePollOption(index: number) {
    if (this.pollOptions.length > 2) {
      this.pollOptions.splice(index, 1);
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  createPoll() {
    if (!this.newPollQuestion.trim()) return;
    const validOptions = this.pollOptions.filter(o => o.trim());
    if (validOptions.length < 2) return;
    if (!this.currentUser.subscriptionActive) {
      this.modalService.open(this.unlockPremiumModalContent, { centered: true, windowClass: 'unlock-premium' })
      return;
    }

    // Edit mode — PUT update (resets votes on the server)
    if (this.editingPollId) {
      this.dashboardService.updatePollApi(
        this.editingPollId,
        this.newPollQuestion.trim(),
        validOptions.map(o => o.trim()),
        this.allowMultipleSelections,
      ).subscribe((response: any) => {
        if (response.success) {
          const idx = this.polls.findIndex(p => p._id === this.editingPollId);
          if (idx !== -1) {
            this.polls[idx] = { ...response.data, userVoted: false, selectedOptions: [] };
          }
          this.toasterService.success('Poll updated. Votes reset.', 'Success');
          this.closePollModal();
        }
      }, () => {
        this.toasterService.error('Failed to update poll', 'Error');
      });
      return;
    }

    const videoId = !this.isDashboard && this.videoId ? this.videoId : undefined;
    this.dashboardService.createPollApi(
      this.pathwayId,
      this.newPollQuestion.trim(),
      validOptions.map(o => o.trim()),
      this.allowMultipleSelections,
      videoId
    ).subscribe((response: any) => {
      if (response.success) {
        response.data.userVoted = false;
        response.data.selectedOptions = [];
        this.polls.unshift(response.data);
        this.showPollModal = false;
      }
    }, () => {
      this.toasterService.error('Failed to create poll', 'Error');
    });
  }

  getValidPollOptionsCount(): number {
    return this.pollOptions.filter(o => o.trim()).length;
  }

  selectPollOption(poll: any, optionIndex: number) {
    if (poll.userVoted) return;
    if (!poll.selectedOptions) poll.selectedOptions = [];
    if (poll.allowMultiple) {
      const idx = poll.selectedOptions.indexOf(optionIndex);
      if (idx > -1) {
        poll.selectedOptions.splice(idx, 1);
      } else {
        poll.selectedOptions.push(optionIndex);
      }
    } else {
      poll.selectedOptions = [optionIndex];
    }
  }

  submitVote(poll: any) {
    if (poll.userVoted || !poll.selectedOptions || poll.selectedOptions.length === 0) return;
    this.dashboardService.submitPollVote(poll._id, poll.selectedOptions).subscribe((response: any) => {
      if (response.success) {
        // Update poll with server data
        const updated = response.data;
        poll.options = updated.options;
        poll.totalVotes = updated.totalVotes;
        poll.userVoted = true;
        this.toasterService.success('Vote submitted!', 'Success');
      }
    }, (error) => {
      if (error.error && error.error.message === 'Already voted') {
        poll.userVoted = true;
        this.toasterService.warning('You have already voted on this poll', 'Warning');
      } else {
        this.toasterService.error('Failed to submit vote', 'Error');
      }
    });
  }

  getVotePercentage(poll: any, option: any): number {
    if (poll.totalVotes === 0) return 0;
    return Math.round((option.votes / poll.totalVotes) * 100);
  }

  canDeletePoll(poll: any): boolean {
    if (!this.currentUser) return false;
    if (this.currentUser.role === 'SUPER_USER') return true;
    if (this.currentUser._id === this.createdBy) return true;
    if (poll.createdBy && poll.createdBy._id === this.currentUser._id) return true;
    return false;
  }

  deleteSelectedPoll(poll: any) {
    this.pendingDeleteItem = poll;
    this.pendingDeleteType = 'poll';
    this.alterMessage = 'Do you want to delete this poll?';
    this.modalService.open(this.deleteConfirmContent, { centered: true, windowClass: 'unlock-premium' });
  }

  confirmDelete() {
    if (this.pendingDeleteType === 'question' && this.pendingDeleteItem) {
      this.dashboardService.deleteEngagementQuestion(this.pendingDeleteItem._id).subscribe((response: any) => {
        if (response.success) {
          this.questions = this.questions.filter(q => q._id !== this.pendingDeleteItem._id);
          this.pendingDeleteItem = null;
        }
      }, () => {
        this.toasterService.error('Failed to delete question', 'Error');
        this.pendingDeleteItem = null;
      });
    } else if (this.pendingDeleteType === 'poll' && this.pendingDeleteItem) {
      this.dashboardService.deletePoll(this.pendingDeleteItem._id).subscribe((response: any) => {
        if (response.success) {
          this.polls = this.polls.filter(p => p._id !== this.pendingDeleteItem._id);
          this.pendingDeleteItem = null;
        }
      }, () => {
        this.toasterService.error('Failed to delete poll', 'Error');
        this.pendingDeleteItem = null;
      });
    } else if (this.pendingDeleteType === 'note' && this.pendingDeleteItem) {
      const note = this.pendingDeleteItem;
      const label = !note.isPrivate ? 'comment' : 'note';
      this.dashboardService.deleteNoteApi(note._id).subscribe((response: any) => {
        if (response.success) {
          this.personalNotes = this.personalNotes.filter(n => n._id !== note._id);
          // Success toast comes from HttpAPIInterceptor (response.body.message); avoid duplicate here.
        }
        this.pendingDeleteItem = null;
      }, () => {
        this.toasterService.error(`Failed to delete ${label}`, 'Error');
        this.pendingDeleteItem = null;
      });
    }
  }

  cancelDelete() {
    this.pendingDeleteItem = null;
    this.pendingDeleteType = '';
  }

  // ==================== Reorder Questions & Polls ====================

  dropQuestion(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
    const orderedIds = this.questions.map(q => q._id);
    this.dashboardService.reorderQuestions(orderedIds).subscribe(() => {}, () => {
      moveItemInArray(this.questions, event.currentIndex, event.previousIndex);
      this.toasterService.error('Failed to reorder questions', 'Error');
    });
  }

  dropPoll(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.polls, event.previousIndex, event.currentIndex);
    const orderedIds = this.polls.map(p => p._id);
    this.dashboardService.reorderPolls(orderedIds).subscribe(() => {}, () => {
      moveItemInArray(this.polls, event.currentIndex, event.previousIndex);
      this.toasterService.error('Failed to reorder polls', 'Error');
    });
  }

  // ==================== AI Suggestions ====================

  toggleAiSuggestions() {
    this.showAiSuggestions = !this.showAiSuggestions;
  }

  resetAiSuggestions() {
    this.showAiSuggestions = false;
  }

  /**
   * Open the Add Question modal pre-filled with an AI suggestion so the user
   * can refine the wording / options before it's persisted. Nothing is created
   * until they press the modal's submit button.
   */
  addSuggestedQuestion(suggestion: any) {
    this.showQuestionModal = true;
    this.editingQuestionId = ''; // create path, not update
    this.newQuestionText = suggestion && suggestion.text ? String(suggestion.text) : '';
    const t = suggestion && suggestion.type ? String(suggestion.type) : 'Open-Ended';
    // Normalise whatever the model returned to our three supported types.
    const lower = t.toLowerCase();
    if (lower.includes('multiple')) this.newQuestionType = 'Multiple Choice';
    else if (lower.includes('true') || lower.includes('false')) this.newQuestionType = 'True/False';
    else this.newQuestionType = 'Open-Ended';

    if (this.newQuestionType === 'Multiple Choice') {
      const opts = Array.isArray(suggestion.options) ? suggestion.options.map((o: any) => String(o)) : [];
      while (opts.length < 2) opts.push('');
      this.newQuestionOptions = opts;
    } else {
      this.newQuestionOptions = ['', ''];
    }
  }

  /**
   * Open the Create Poll modal pre-filled with an AI suggestion so the user
   * can refine it before it's persisted.
   */
  addSuggestedPoll(suggestion: any) {
    this.showPollModal = true;
    this.editingPollId = ''; // create path
    this.newPollQuestion = suggestion && suggestion.text ? String(suggestion.text) : '';
    const opts = Array.isArray(suggestion.options) ? suggestion.options.map((o: any) => String(o)) : [];
    while (opts.length < 2) opts.push('');
    this.pollOptions = opts;
    this.allowMultipleSelections = !!(suggestion && suggestion.allowMultiple);
  }

}
